import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    // Handle sources that use data-video-source (legacy) or already have src (from video_tag)
    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      // If source already has src (from video_tag), skip setting it
      // Otherwise, set src from data-video-source attribute
      if (videoSource && !source.hasAttribute('src')) {
        source.setAttribute('src', videoSource);
      }
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
